import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/admin/chat-feedback/`;

const withQuery = (path, params = {}) => {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
  const queryString = new URLSearchParams(clean).toString();
  return API_URL + path + (queryString ? `?${queryString}` : "");
};

/* ---------- import (supervisor) ---------- */

/** { isSupervisor, adminId, chatconeName } */
const getMe = () => axios.get(API_URL + "me");

/** Admins who can receive feedback: [{ id, nickname, chatconeName }] */
const getAdmins = () => axios.get(API_URL + "admins");

/**
 * Map a name from the report to an admin, permanently. Writes only
 * admins.chatconeName — not the settings endpoint, which re-derives payroll.
 */
const setChatconeName = (adminId, chatconeName) => axios.patch(`${API_URL}admins/${adminId}`, { chatconeName });

/** { reportDate, adminVolume, cases } → { created, skipped, errors } */
const importCases = (payload) => axios.post(API_URL + "import", payload);

/* ---------- admin side ---------- */

/** { pending, discussing, overdue, nextDueAt } — drives the KeyData banner */
const getUnreadCount = () => axios.get(API_URL + "unread-count");

/** { items, remember } — my cases without chat logs, pending first. Supervisors may pass { adminId } to preview someone's. */
const getInbox = (params = {}) => axios.get(withQuery("inbox", params));

/** One case in full: recipient row + case (with chatLog) + comments */
const getRecipient = (recipientId) => axios.get(`${API_URL}recipient/${recipientId}`);

/** รับทราบ: { answer, answerNext (fix only), readSeconds } */
const acknowledge = (recipientId, payload) => axios.post(`${API_URL}recipient/${recipientId}/acknowledge`, payload);

/** ขอชี้แจง: opens the thread with the admin's reason */
const dispute = (recipientId, message) => axios.post(`${API_URL}recipient/${recipientId}/dispute`, { message });

/** Reply in the thread (admin or supervisor) */
const createComment = (recipientId, content) => axios.post(`${API_URL}recipient/${recipientId}/comments`, { content });

/* ---------- supervisor side ---------- */

/** verdict: 'understood' | 'withdrawn' | 'upheld' (upheld needs a comment) */
const setVerdict = (recipientId, { verdict, comment }) => axios.post(`${API_URL}recipient/${recipientId}/verdict`, { verdict, comment });

/** Answers to judge, disputes, and overdue cases, in one list. params: { page, startDate, endDate } */
const getReviewQueue = (params = {}) => axios.get(withQuery("review-queue", params));

/** Per-admin numbers, weekly trend, latest-batch summary. params: { page, startDate, endDate } */
const getDashboard = (params = {}) => axios.get(withQuery("dashboard", params));

/** System-side problems, open first */
const getBackoffice = () => axios.get(API_URL + "backoffice");

/** { status?, owner?, note?, move? } — move: true pulls a sent case out of every inbox */
const updateBackoffice = (caseId, payload) => axios.patch(`${API_URL}case/${caseId}/backoffice`, payload);

const ChatFeedbackService = {
  getMe,
  getAdmins,
  setChatconeName,
  importCases,
  getUnreadCount,
  getInbox,
  getRecipient,
  acknowledge,
  dispute,
  createComment,
  setVerdict,
  getReviewQueue,
  getDashboard,
  getBackoffice,
  updateBackoffice,
};

export default ChatFeedbackService;
